import $ from "jquery";
import Swiper from "swiper"
import {breakpointDown, breakpointUp} from "./Breakpoints";

export default {
    heroSwiperInstance: null,
    socialSwiperInstance: null,
    init() {

        if ($("body").hasClass("home")) {
            this.initHeroSwiper()
            this.initSocialSwiper()
        }
    },
    initHeroSwiper() {
        this.heroSwiperInstance = new Swiper(".home-hero-swiper", {
            effect: "fade",
            speed: 900,
            disableOnInteraction: false,
            autoplay: {
                delay: 4000,
            },
            simulateTouch: false,
            loop: true,
            on: {
                slideChangeTransitionStart: function () {
                    let prevHtml = $(".home-hero-swiper .swiper-slide-prev .titre").html()
                    let nextHtml = $(".home-hero-swiper .swiper-slide-active .titre").html()
                    if (prevHtml !== nextHtml) {
                        $(".home-hero-swiper .swiper-slide-prev .titre").hide()
                        $(".home-hero-swiper .swiper-slide-active .titre").hide()
                        setTimeout(function () {
                            $(".home-hero-swiper .swiper-slide-active .titre").fadeIn()
                        }, 400)
                    } else {
                        $(".home-hero-swiper .swiper-slide-prev .titre").show()
                        $(".home-hero-swiper .swiper-slide-active .titre").show()
                    }
                },
            }

        });
    },
    initSocialSwiper() {

        if (breakpointUp("lg")) {
            this.socialSwiperInstance = new Swiper(".home-social-swiper", {
                watchOverflow: true,
                simulateTouch: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                // threshold:20,
                on: {
                    slideChange: function () {
                        let $prevButton = $("section.home-social .swiper-pagination .icon-arrow-right.go-left")
                        if (this.isBeginning) {
                            $prevButton.addClass("deactivate")
                        } else {
                            $prevButton.removeClass("deactivate")
                        }

                        let $nextButton = $("section.home-social .swiper-pagination .icon-arrow-right.go-right")
                        if (this.isEnd) {
                            $nextButton.addClass("deactivate")
                        } else {
                            $nextButton.removeClass("deactivate")
                        }

                    }
                }
            });

            $(document).on("click", "section.home-social .swiper-pagination .icon-arrow-right", event => {
                let classListElement = $(event.currentTarget).attr("class").split(/\s+/)
                if (classListElement[1] === "go-right") {
                    this.socialSwiperInstance.slideNext()
                } else {
                    this.socialSwiperInstance.slidePrev()
                }


            });

        }


    }


};